<template>
  <div id="app">
    <div class="">
      <component :is="layout">
        <router-view />
      </component>
      <vue-snotify></vue-snotify>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

const default_layout = 'default'
export default Vue.extend({
  mounted() {
    this.getTitle(this.$route)
  },
  methods: {
    getTitle(route) {
      document.title = `${route.meta.title} | Refácil`
    },
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || default_layout}-layout`
    },
  },
  watch: {
    $route(to) {
      this.getTitle(to)
    },
  },
})
</script>
<style lang="scss">
@import '~vue-snotify/styles/simple';
@import 'assets/style.scss';
</style>
